import { Button, Checkbox, Form, Input, Modal, Row } from "antd";
import { useState } from "react";

const rules = [{ required: true }];

export function NewThreadModal(props: { onCancel: VoidFunction; onCreate: (content: string) => void }) {
  const [isToc, setToc] = useState(false);
  const [form] = Form.useForm();

  async function onCreate() {
    try {
      await form.validateFields();
    } catch {
      return;
    }

    props.onCreate(form.getFieldValue("content"));
  }

  return (
    <>
      <Modal visible={true} title="New Thread" onCancel={props.onCancel} footer={null} maskClosable={false}>
        <Form form={form} labelCol={{ span: 0 }}>
          <Form.Item name="title" rules={rules}>
            <Input placeholder="title" />
          </Form.Item>
          <Form.Item name="content" rules={rules}>
            <Input.TextArea rows={5} placeholder="thread content" />
          </Form.Item>
        </Form>
        <Row style={{ marginBottom: 12 }}>
          <Checkbox checked={isToc} style={{ marginRight: 6 }} onChange={() => setToc(!isToc)} />
          <span>This thread follows terms of use.</span>
        </Row>
        <Row justify="center">
          <Button disabled={!isToc} type="primary" onClick={onCreate}>
            Post
          </Button>
        </Row>
      </Modal>
    </>
  );
}
